export default "__VITE_ASSET__VMvTuViQ__"